import {
  IconAdjustments,
  IconBrain,
  IconFileText,
  IconPhotoUp,
  IconPlug,
  IconBarbell,
  type Icon,
} from "@tabler/icons-react";

export const AGENT_TABS = [
  "instrucoes",
  "cerebro",
  "galeria",
  // SA-1434: valor em inglês, pela regra de URL do projeto (`?tab=behavior`);
  // as abas mais antigas ficaram com o nome em português.
  "behavior",
  "integracoes",
  // SA-1486: feedbacks da IA, só leitura (`?tab=training`).
  "training",
] as const;

export type AgentTab = (typeof AGENT_TABS)[number];

export const AGENT_TAB_LABELS: Record<AgentTab, string> = {
  instrucoes: "Instruções",
  cerebro: "Cérebro",
  galeria: "Galeria",
  integracoes: "Integrações",
  behavior: "Comportamento",
  training: "Treinamento",
};

/** Ícone de cada aba (mesma escolha do protótipo da SA-1351). */
export const AGENT_TAB_ICONS: Record<AgentTab, Icon> = {
  instrucoes: IconFileText,
  cerebro: IconBrain,
  galeria: IconPhotoUp,
  integracoes: IconPlug,
  behavior: IconAdjustments,
  training: IconBarbell,
};

/** Query param da aba (`/agent?tab=galeria`): lido na montagem, gravado na troca. */
export const AGENT_TAB_QUERY_PARAM = "tab";

export const isAgentTab = (
  value: string | null | undefined
): value is AgentTab => (AGENT_TABS as readonly string[]).includes(value ?? "");
